import { Alert, Color } from '@material-ui/lab';

import styles from './StoreAuditAlert.styles';
import { OrderId } from 'shared/domain';
import { useStoreAuditAlert } from './useStoreAuditAlert';

export function StoreAuditAlert({ orderId, hasWrapper = false }: Props) {
  const _classes = styles();

  const { errorText, isAllChecked, successText, title } = useStoreAuditAlert({
    orderId,
  });

  const config = {
    success: {
      severity: 'success' as Color,
      text: successText,
      rootClass: _classes.alertDefectProductCheckeded,
    },
    error: {
      severity: 'error' as Color,
      text: errorText,
      rootClass: _classes.alertDefectProductNotCheckeded,
    },
  };
  const { severity, text, rootClass } = isAllChecked
    ? config.success
    : config.error;

  if (!hasWrapper) {
    return (
      <Alert
        severity={severity}
        classes={{
          root: rootClass,
          message: _classes.alertMessage,
        }}
      >
        <span>{text}</span>
      </Alert>
    );
  }

  return (
    <div className={_classes.container}>
      <h3 className={_classes.title}>{title}</h3>
      <Alert
        severity={severity}
        classes={{
          root: rootClass,
          message: _classes.alertMessage,
        }}
      >
        <span>{text}</span>
      </Alert>
    </div>
  );
}

type Props = {
  orderId: OrderId;
  hasWrapper?: boolean;
};
